import qs from 'qs';

const protocol = document.location.protocol;

const padStart = (value, length, char) => {
  value = value + '';
  const len = length - value.length;

  if (len <= 0) {
    return value;
  }
  else {
    return Array(len + 1).join(char) + value;
  }
};

// URL 协议自适应
export const replaceUrlProtocol = (url) => String(url).replace(/^https?:(\/\/.+?)$/i, protocol + '$1');

// 简易枚举函数
// 用法 {{ status | enmus(可能的值的数组, 默认值) }}
// 如果当前值在“可能的值的数组”的 key 中，则返回这个 key 对应的 value，否则返回默认值（默认为空字符串）
// {{ status | enums({0: '状态1', 1: '状态2', 2: '状态3'}) }}
export function enums(key, values, defaultValue = '') {
  if (typeof values !== 'object') {
    return defaultValue;
  }

  if (typeof values[key] != 'undefined') {
    return values[key];
  }
  else {
    return defaultValue;
  }
};

// 格式化日期
export function format(date, format = 'YYYY-MM-DD hh:mm:ss') {
  let _date = date;
  const splitArr = format.split(/(YYYY|MM|DD|hh|mm|ss)+/);

  if (typeof date !== 'object') {
    // 服务器时间戳需要转成 js 时间戳
    _date = new Date(Number(date) * 1000);
  }

  return splitArr.map(item => {
    if (item == 'YYYY') {
      return _date.getFullYear();
    }

    if (item == 'MM') {
      return padStart(_date.getMonth() + 1, 2, 0);
    }

    if (item == 'DD') {
      return padStart(_date.getDate(), 2, 0);
    }

    if (item == 'hh') {
      return padStart(_date.getHours(), 2, 0);
    }

    if (item == 'mm') {
      return padStart(_date.getMinutes(), 2, 0);
    }

    if (item == 'ss') {
      return padStart(_date.getSeconds(), 2, 0);
    }

    return item;
  }).join('');
};

// 显示唱吧头像或封面
// 用法 {{ url | avatar(size, default) }}
// size 是标准唱吧头像支持的像素大小
// {{ url | avatar(200) }}
export function avatar(url, size = 200, defaultValue = '') {
  if (!url) {
    return replaceUrlProtocol(defaultValue);
  }

  url = String(url);

  const reg = /^\S+_\d+_\d+.(?:png|jpg|jpeg|gif|webp)$/i;

  return replaceUrlProtocol(reg.test(url) ? url : url.replace(/.[^.]+$/, `_${size}_${size}$&`));
};

// 生成 App 协议
// 用法 {{ { ac: 'test', param1: 'p1', param2: 'p2' } | appProtocolUrl }}
export function appProtocolUrl(params, protocol = 'changba') {
  return `${protocol}://?${qs.stringify(params)}`;
};
